var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login-b"},[_vm._m(0),_c('div',{staticClass:"logout-b",on:{"click":_vm.logout}},[_c('span',[_vm._v("登出")])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"name-b"},[_c('i',{staticClass:"el-icon-s-custom"})])
}]

export { render, staticRenderFns }